(function (upp, SirTrevorAdapter) {
    FreeContentAdapterService.$inject = [ '$q', '$sce' ];
    function FreeContentAdapterService($q, $sce) {
        Object.defineProperties(this, {
            $q: { value: $q },
            $sce: { value: $sce },
            adapter: { value: new SirTrevorAdapter() }
        });
    }

    /**
     * Given a free module content from the api (a string) returns the HTML to
     * be rendered on the childupp.
     *
     * The input content can be one of the following:
     * - An HTML string which would be return as is.
     * - A JSON parseable string which would be parsed with SirTrevorAdapter,
     *  converted to HTML and return said conversion
     *
     * @param {string} content - The contents to be parsed
     * @return {Promise<string>} - A trusted HTML to be rendered
     */
    FreeContentAdapterService.prototype.parseContent = function(content) {
        if (typeof content !== 'string')
            content = String(content);
        // Since we do a first-char check, better trim it out, eventho this is
        // probably not necessary
        content = content.trim();

        // If content is a JSON string, it will probably start by one of this characters
        var isJsonString = [ '{', '[' ].indexOf(content.charAt(0)) >= 0;

        if (isJsonString) {
            var modules = JSON.parse(content);
            content = this.adapter.toHTML(modules);
        }

        // Return a promise eventhough this is code is sync for forcing
        // our consumers to work asynchronusly, since this spec can change
        return this.$q.when(this.$sce.trustAsHtml(content));
    }

    upp.service('freeContentAdapterService', FreeContentAdapterService);
})(upp, window.SirTrevorAdapter);


// WEBPACK FOOTER //
// ./src/app/modules/free/services/free-content-adapter.service.js